module.exports = __webpack_public_path__ + "static/media/cp5.f37b819d.png";